/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, convertHexToRGB, replacePXinStringWithEM, color, textShadow } from 'utils/styles';



/* ++++++++++ --------------- BUTTON STYLES --------------- ++++++++++ */
export default {
	button: {
		backgroundColor: color.blueLight, // modified by passed color prop that equates to a class
		border: '0',
		borderRadius: pxToEm(3),
		color: color.white,
		cursor: 'pointer',
		display: 'block',
		marginLeft: 'auto',
		marginRight: 'auto',
		fontSize: pxToEm(14),
		lineHeight: '1',
		fontWeight: '600',
		textTransform: 'capitalize',
		// width: '100%',
		maxWidth: pxToEm(400),
		padding: replacePXinStringWithEM('10px 0 13px'),
		extend: textShadow.medium,
		'&.blue': { 
			backgroundColor: color.blueLight,
			'&:hover': { backgroundColor: convertHexToRGB(color.blueLight, 80) }
		},
		'&.orange': { 
			backgroundColor: color.orangeLight,
			'&:hover': { backgroundColor: convertHexToRGB(color.orangeLight, 80) }
		},
		'&.green': { 
			backgroundColor: color.green,
			'&:hover': { backgroundColor: convertHexToRGB(color.green, 80) }
		},
		'&.white': { 
			backgroundColor: color.white,
			color: color.blueLight,
			textShadow: 'none',
			textTransform: 'none',
			'&:hover': { backgroundColor: convertHexToRGB(color.white, 90) }
		},
		'&.enter': { 
			backgroundColor: color.white,
			color: color.greyDarker,
			textShadow: 'none',
			textTransform: 'none',
			boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.1), inset 0 -1px 2px 0 rgba(173, 173, 173, 0.4)',
			'&.disabled': {
                cursor: 'default',
                pointerEvents: 'none',
                '&:hover': { backgroundColor: color.white }
            },
			'&:hover': { backgroundColor: convertHexToRGB(color.white, 90) }
		},

		transition: 'background .2s linear 0s'
	}
};
